import { AiPromptSummaryResponse } from '@ydistri/api-sdk';
import { Row, YColumnsType } from '@ydistri/ds';
import { formatDateTime } from '@ydistri/generic-utils';
import { computeRemSize } from '@ydistri/theme';
import { Tag } from 'antd';
import React from 'react';
import { authorName } from './aiPromptsLib';

interface ColumnFactoryOptions {
  renderActions: (record: AiPromptSummaryResponse) => React.ReactNode;
}

export const getAiPromptColumns = ({
  renderActions,
}: ColumnFactoryOptions): YColumnsType<AiPromptSummaryResponse>[] => [
  {
    title: 'Title',
    key: 'title',
    ellipsis: true,
    render: (record: AiPromptSummaryResponse) => (
      <Row $gap="0.5rem" $alignItems="center">
        {record.title}
        {record.isSuperUserOnly === true && <Tag bordered={false}>Superadmin only</Tag>}
      </Row>
    ),
  },
  {
    title: 'Version',
    dataIndex: 'versionNumber',
    key: 'versionNumber',
    width: computeRemSize(90),
  },
  {
    title: 'Changed',
    key: 'createdAt',
    width: computeRemSize(180),
    render: (record: AiPromptSummaryResponse) => formatDateTime(record.createdAt),
  },
  {
    title: 'Changed by',
    key: 'createdBy',
    width: computeRemSize(200),
    render: (record: AiPromptSummaryResponse) => authorName(record.createdBy),
  },
  {
    title: '',
    key: 'actions',
    width: computeRemSize(130),
    align: 'right',
    render: (record: AiPromptSummaryResponse) => renderActions(record),
  },
];
